<template>
    <tr>
        <td> {{ item.name }}</td>
        <td><span class="label" :style="{ 'background-color': item.color }"> {{ item.color }} </span></td>
        <td class="t_center">
            <pml-switch :value="item.active" @input="toggleActive()"></pml-switch>
        </td>
        <td class="t_center">
            <router-link :to="{ name: 'sources.edit', params: { id: item.id } }" class="btn btn-warning btn-xs" v-pml-tooltip="$t('edit')">
                <i class="fa-fw fa fa-pencil"></i>
            </router-link>
            <span class="btn btn-danger btn-xs" v-pml-tooltip="$t('delete')" @click.prevent="askToDelete()" v-pml-block="isDeleting">
                <i class="fa-fw fa fa-times"></i>
            </span>
        </td>
    </tr>
</template>

<script>
    import Notify from 'utils/helpers/notify'
    import { trans } from 'utils/helpers/translation'
    import { destroy, toggle } from 'services/sources'
    import { askToDelete } from 'utils/helpers/sweet-alert'

    export default {
        name: 'SourceItem',
        props: [ 'item' ],
        data () {
            return {
                isDeleting: false
            }
        },
        methods: {
            askToDelete () {
                askToDelete()
                    .then((response) => (response.value) ? this.destroy() : null)
            },
            destroy () {
                this.isDeleting = true

                destroy(this.item.id)
                    .then(() => Notify.success(trans('_notifications.success')))
                    .catch(error => Notify.error(trans(error.response.data.slug)))
                    .then(() => { this.isDeleting = false })
            },
            toggleActive () {
                toggle(this.item.id, 'active')
                    .then(response => Notify.success(trans('_notifications.success')))
                    .catch((error) => {
                        Notify.error(error.response.data)
                        this.item.active = !this.item.active
                    })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/parameters/sources/components/Item.vue